import MostPopularProduct from './MostPopularProduct';

export default {
  MostPopularProduct,
};
